import { useEffect, useState } from "react";

function normalizeSrc(src) {
	if (src == null) return "";
	const trimmed = String(src).trim();
	return trimmed;
}

function ImagePlaceholderIcon({ className }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
		>
			<rect x="3" y="5" width="18" height="14" rx="2" opacity="0.9" />
			<circle cx="8.5" cy="10" r="1.75" />
			<path d="M21 16l-5.2-5.2a1.2 1.2 0 0 0-1.6 0L8 17" />
		</svg>
	);
}

function CoverEmptyState({ variant = "cover", label = "بدون تصویر" }) {
	const surface =
		"absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#E8F3FC] via-[#F4F9FD] to-[#C5DCF2] ring-1 ring-inset ring-darkBlue/10";

	if (variant === "play") {
		return (
			<div className={surface} role="img" aria-label={label}>
				<span className="flex h-12 w-12 items-center justify-center rounded-full bg-white/95 text-[18px] text-darkBlue/75 shadow-[0_4px_12px_rgba(39,106,166,0.12)]">
					▶
				</span>
			</div>
		);
	}

	return (
		<div className={surface} role="img" aria-label={label}>
			<ImagePlaceholderIcon className="h-10 w-10 text-darkBlue/35" />
			<span className="font-Vazir-400 text-[11px] text-darkBlue/45">{label}</span>
		</div>
	);
}

/**
 * کاور کارگاه / وبینار / کلیپ — نسبت ۴:۳ با object-cover
 */
export default function CatalogCoverImage({
	src,
	alt = "",
	roundedClassName = "rounded-[10px]",
	className = "",
	imgClassName = "",
	emptyVariant = "cover",
	emptyLabel = "بدون تصویر",
	/** cover = crop to fill tile; contain = full image (detail banners) */
	fit = "cover",
	aspectClassName = "aspect-[4/3]",
}) {
	const objectFit =
		fit === "contain" ? "object-contain" : "object-cover";
	const [imgError, setImgError] = useState(false);
	const resolvedSrc = normalizeSrc(src);
	const showImage = resolvedSrc && !imgError;

	useEffect(() => {
		setImgError(false);
	}, [resolvedSrc]);

	return (
		<div
			className={[
				"relative w-full min-w-0 max-w-full overflow-hidden bg-lightCta",
				aspectClassName,
				roundedClassName,
				className,
			].join(" ")}
		>
			{showImage ? (
				<img
					src={resolvedSrc}
					alt={alt}
					loading="lazy"
					decoding="async"
					onError={() => setImgError(true)}
					className={[
						"absolute inset-0 h-full w-full max-w-full object-center",
						objectFit,
						imgClassName,
					].join(" ")}
				/>
			) : (
				<CoverEmptyState
					variant={emptyVariant}
					label={emptyLabel || alt || "بدون تصویر"}
				/>
			)}
		</div>
	);
}
